// @ts-nocheck
import { Div, P } from '@kizi/core-components';
import { ComparatorContext, getHomeCoverages } from '@kizi/comparator-core';
import _ from 'lodash';
import React, { useContext } from 'react';
import { TariffsTabProps } from '.';
import { formatPrice } from '../../../../../utils/global';
import { getLabel } from '../../../../../utils/translations';
import { ListComp } from '../../../../Product/ExpandedPart/List';
import { Anchor } from '@kizi/shared-components';

const labels = {
  'Inboedel- en Woonhuisverzekering':
    'customProperties.buildingHomeCombinationTotalInstallmentAmount',
  Inboedelverzekering: 'coverageHomes.totalInstallmentAmount',
  Woonhuisverzekering: 'coverageBuildings.totalInstallmentAmount',
  Aansprakelijkheidsverzekering: 'coverageLiabilities.totalInstallmentAmount',
  // Temporary hide these fields
  // Pakketkorting: 'packageDiscountInstallmentAmount',
  // Servicevergoeding: 'costsInstallmentAmount',
  Administratiekosten: 'installmentAmountRenewalCharges',
  total: 'totalInstallmentAmount',
  'Eenmalige poliskosten van de verzekeraar': 'oneOffCostsAmount',
};

const showValueWhenZero = ['Eenmalige poliskosten van de verzekeraar'];

export const TariffsTabHome: React.FC<TariffsTabProps> = ({
  data,
  priceMode,
}) => {
  const { homePackage } = data;
  const { name } = useContext(ComparatorContext);
  if (!homePackage) return null;
  const {
    renewalCommissionInstallmentAmountPartner,
    renewalCommissionInstallmentNumberOfMonths,
    renewalCommissionInstallmentAmountLink,
  } = data.commissionTransparency || {};

  const transparency = renewalCommissionInstallmentAmountPartner ? (
    <P
      variant="footnoteRegular"
      color="second.0"
      fontSize={0}
      fontWeight={0}
      pb={[2, 3]}
      css={{ lineHeight: '150%' }}
    >
      {name === 'os-home' ? (
        <>
          Voor de activiteiten die wij doen, ontvangen wij een vergoeding van
          gemiddeld
          <strong>
            {' '}
            €{parseFloat(renewalCommissionInstallmentAmountPartner).toFixed(2).replace('.', ',')} per maand
          </strong>
          , uitgaande van een gemiddelde looptijd van
          <strong> {renewalCommissionInstallmentNumberOfMonths} maanden</strong>
          . Meer informatie over hetgeen wij doen,{' '}
          <Anchor
            href={renewalCommissionInstallmentAmountLink}
            target="_blank"
            color="main.1"
          >
            vind je hier
          </Anchor>
          .
        </>
      ) : (
        <>
          Voor de activiteiten die wij doen, ontvangen wij een eenmalige
          vergoeding van
          <strong> €{renewalCommissionInstallmentAmountPartner}</strong>. Dit
          bedrag is verwerkt in de premie. Meer informatie over wat wij doen,{' '}
          <Anchor
            href={renewalCommissionInstallmentAmountLink}
            target="_blank"
            color="main.1"
          >
            vind je hier
          </Anchor>
          .
        </>
      )}
    </P>
  ) : null;
  const coverages = getHomeCoverages(homePackage);

  const isOnlyLiability =
    coverages.coverageBuildings === null && coverages.coverageHomes === null;

  return (
    <>
      <Div color="main.2" fontWeight={1} mb={3}>
        Overzicht van je kosten
      </Div>
      <Div display={[null, null, 'flex']}>
        <ListComp
          groups={[
            {
              list: [
                ...Object.keys(labels)
                  .map((label) => {
                    const valueSource = labels[label];
                    const value = _.get(
                      valueSource.startsWith('coverage')
                        ? coverages
                        : homePackage,
                      valueSource,
                    );
                    if (label === 'total') {
                      return {
                        bold: !isOnlyLiability,
                        label: getLabel(`${priceMode}lyAmount`),
                        value,
                      };
                    } else {
                      return {
                        label,
                        value,
                      };
                    }
                  })
                  .filter((field) => {
                    if (
                      Number(field.value) ||
                      showValueWhenZero.includes(field.label)
                    ) {
                      return field;
                    } else {
                      return;
                    }
                  })
                  .map(({ value, ...restProps }) => {
                    return {
                      ...restProps,
                      value: formatPrice(value, 2),
                    };
                  }),
                {
                  label: (
                    <Div flexDirection={'column'} display={'flex'}>
                      {transparency}
                      <P variant="footnoteRegularLight" fontSize={0}>
                        Premie en kosten zijn inclusief 21% assurantiebelasting
                      </P>
                    </Div>
                  ),
                  noRightField: true,
                },
              ],
              title: getLabel(`${priceMode}lyCosts`),
            },
          ]}
        />
      </Div>
    </>
  );
};
